import type { AnnouncementListDto } from '@bldsoft/cappie/api/wbs'
import type { ListenEvent } from '@bldsoft/cappie/rest'

import { createEvent, sample } from 'effector'
import { client } from '~/core/api/client'
import { createListen } from '~/shared/effector'

export const init = createEvent()
export const received = createEvent<AnnouncementListDto>()

const {
  start,
  stop: _unused,
  event,
} = createListen(client.get.api.device.announcements)

sample({
  clock: init,
  target: start,
})

type CappieEvent = ListenEvent<typeof client.get.api.device.announcements>
type ResultEvent = CappieEvent & {
  result: { kind: 'success'; payload: AnnouncementListDto }
}

sample({
  clock: event,
  filter: (data: CappieEvent): data is ResultEvent =>
    data.phase === 'result' &&
    data.result.kind === 'success' &&
    data.result.payload != null,
  fn: (data) => data.result.payload,
  target: received,
})
